import { render, staticRenderFns } from "./Cam.vue?vue&type=template&id=6a886954&scoped=true&"
import script from "./Cam.vue?vue&type=script&lang=js&"
export * from "./Cam.vue?vue&type=script&lang=js&"
import style0 from "./Cam.vue?vue&type=style&index=0&id=6a886954&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a886954",
  null
  
)

export default component.exports